import { defineStore } from "pinia";
import { directus } from "../services/directus";
import { readItems } from "@directus/sdk";
import { usePreferencesStore } from "./preferences";

export const useMenuStore = defineStore("navigation_menus", {
  state: () => ({
    main_menu: [],
    footer_menu: [],
    footer_bottom_navigation: [],
    _loaded: false,
  }),
  getters: {
    getMenuItemByPath: (state) => {
      return (slug) => {
        const allItems = [];
        const menu_items = [].concat(
          state.main_menu,
          state.footer_menu,
          state.footer_bottom_navigation
        );
        menu_items.forEach((item) => {
          //add items to all items
          allItems.push(item);
          if (item.sub_items) {
            item.sub_items.forEach((sub_item) => {
              allItems.push(sub_item);
              if (sub_item.third_items) {
                sub_item.third_items.forEach((sub_sub_item) => {
                  allItems.push(sub_sub_item);
                });
              }
            });
          }
        });
        return allItems.find((item) => item.full_slug == slug);
      };
    },
    getSlugById: (state) => {
      return (id) => {
        const allItems = [];
        const menu_items = [].concat(
          state.main_menu,
          state.footer_menu,
          state.footer_bottom_navigation
        );
        menu_items.forEach((item) => {
          //add items to all items
          allItems.push(item);
          if (item.sub_items) {
            item.sub_items.forEach((sub_item) => {
              allItems.push(sub_item);
              if (sub_item.third_items) {
                sub_item.third_items.forEach((sub_sub_item) => {
                  allItems.push(sub_sub_item);
                });
              }
            });
          }
        });
        return allItems.find((item) => item.page?.key == id)?.full_slug || "#";
      };
    },
  },
  actions: {
    async updateNavigation(type) {

    


      const preferencesStore = usePreferencesStore();
      const language = preferencesStore.language;


       
      try {
        const resp = await directus.request(
          readItems("navigation_menus", {
            fields: ["*.*"],
            filter: { code: { _eq: type } },
          })
        );

        const menu_items =
          resp[0].translations.find(t => t.languages_id === language)?.menu_items
          ?? resp[0].translations[0]?.menu_items
          ?? [];


        if (!menu_items) {
          console.warn(`No menu items found for navigation type: ${type}`);
          return;
        }

        const pre_lang_attr = "en-US" === language ? "/en" : "";

        //SLUG GENERATION FIRST
        menu_items.forEach((item) => {
          if (item.slug) {
            item.full_slug = pre_lang_attr + "/" + item?.slug;
            //SECOND
            item.sub_items?.forEach((sub_item) => {
              sub_item.full_slug = item?.full_slug + "/" + sub_item?.slug;
              //THIRD
              sub_item.third_items?.forEach((sub_sub_item) => {
                sub_sub_item.full_slug =
                  sub_item?.full_slug + "/" + sub_sub_item?.slug;
              });
            });
          } else {
            item.full_slug = "en-US" === language ? "/en" : "/";
          }
        });

        this[type] = menu_items;
      } catch (error) {
        console.error(`Failed to update navigation ${type}:`, error);
        // Keep existing menu items on error to prevent empty navigation
        throw error;
      }
    },
    async updateAllNavigations(force = false) {
      if (this._loaded && !force) return;

      this._loaded = false;

      await Promise.all([
        this.updateNavigation("main_menu"),
        this.updateNavigation("footer_menu"),
        this.updateNavigation("footer_bottom_navigation"),
      ]);

      this._loaded = true;
    }

  },
});
